import {FC} from 'react'
import {PrintStorySeverity} from '../types'
import {severityBadgeClass} from '../severity'

type Props = {
  severity: PrintStorySeverity
  children: React.ReactNode
  className?: string
}

export const SeverityBadge: FC<Props> = ({severity, children, className = ''}) => (
  <span className={`badge ${severityBadgeClass(severity)} ${className}`.trim()}>{children}</span>
)
